// Поиск — fixtures/live/search_*.json (08.10.2026). Режим (catalog | results) выбирает СЕРВЕР.
import type { EmptyState, MatchRow, TeamRef } from './types';

/** league — оценка сервера (09.10): лига, где команда больше всего играла; подпись «Страна • Лига». */
export interface SearchTeam extends TeamRef { country?: string | null; national_team?: boolean; league?: { id: number; name: string } | null }
export interface SearchLeague { id: number; name: string; code?: string | null; image: string | null; country?: string | null }
/** team — команда последнего выхода (09.10); подпись «Команда • Амплуа». */
export interface SearchPlayer {
  id: number; name: string; image: string | null; country?: string | null; position?: string | null;
  team?: { id: number; name: string; image: string | null } | null;
}

export interface SearchResponse {
  mode: 'catalog' | 'results' | string;
  query?: string;
  chips_order: string[];
  blocks_order: string[];
  teams?: SearchTeam[];
  leagues?: SearchLeague[];
  players?: SearchPlayer[];
  matches?: MatchRow[];
  popular_teams?: SearchTeam[];
  popular_leagues?: SearchLeague[];
  popular_players?: SearchPlayer[];
  live_now?: MatchRow[];
  empty_state?: EmptyState;
}

/** Подпись игрока «Команда • Амплуа» (team — серверная, 09.10); в старом ответе — страна · амплуа. */
export const searchPlayerSubtitle = (x: SearchPlayer) => [x.team?.name ?? x.country, x.position].filter(Boolean).join(' • ');
/** Подпись команды «Страна • Лига» (league — оценка сервера). */
export const searchTeamSubtitle = (x: SearchTeam) => [x.country, x.league?.name].filter(Boolean).join(' • ');
